import { render, staticRenderFns } from "./gatherUpload.vue?vue&type=template&id=13e531e7&scoped=true"
import script from "./gatherUpload.vue?vue&type=script&lang=js"
export * from "./gatherUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e531e7",
  null
  
)

export default component.exports